import { Fetch } from '../middleware/fetch';
import ENV from '../../env';
import { normalize } from 'normalizr';
import { url as formatUrl } from '../../util/env';

const isJSON = type => type && type.indexOf('application/json') !== -1;
const isText = type => type && type.indexOf('text/') !== -1;

export class File extends Fetch {
  // eslint-disable-next-line no-unused-vars
  before(action, states, next) {
    const { payload: { json = true, options: { body } = {} } = {} } = action;
    const nextAction = { ...action };
    if (json && body !== undefined) {
      nextAction.payload.options.body = JSON.stringify(body);
    }

    return Promise.resolve(nextAction);
  }
  // eslint-disable-next-line no-unused-vars
  after(action, states, next) {
    const { payload, response } = action;
    const type = response.headers.get('content-type');
    return isJSON(type)
      ? response
          .json()
          .then(data => {
            if (!response.ok) throw response.statusText;
            return data;
          })
          .then(data => {
            if (data.errorMessage) throw data.errorMessage;
            return data;
          })
          .then(data => {
            const { schema } = payload;
            return !schema || typeof data !== 'object'
              ? data
              : normalize(data, schema);
          })
          .then(response => ({ ...action, response }))
      : isText(type)
        ? response
            .text()
            .then(data => {
              if (!response.ok) throw data || response.statusText;
              return data;
            })
            .then(response => ({ ...action, response }))
        : response
            .blob()
            .then(data => {
              if (!response.ok) throw response.statusText;
              return data;
            })
            .then(response => ({ ...action, response }));
  }
}

const file = new File(
  formatUrl(ENV),
  {
    headers: {
      Accept: 'application/json'
    },
    method: 'GET'
  },
  { prefix: 'File' }
);

export default file;



// WEBPACK FOOTER //
// ./js/store/config/file.js